import { render, staticRenderFns } from "./GoodCategorynew.vue?vue&type=template&id=b3f718ee&"
import script from "./GoodCategorynew.vue?vue&type=script&lang=js&"
export * from "./GoodCategorynew.vue?vue&type=script&lang=js&"
import style0 from "./GoodCategorynew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports